<div class="download-rename-dialog">
  <h2 mat-dialog-title>Save file as</h2>

  <mat-dialog-content>
    <p class="dialog-hint">You can rename the file before downloading. Keep the file extension for correct opening.</p>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>File name</mat-label>
      <input matInput [formControl]="fileNameControl" (keyup.enter)="confirm()" />
      @if (data.fileExtension) {
        <mat-hint>Extension: {{ data.fileExtension }}</mat-hint>
      }
      @if (fileNameControl.hasError('required') && fileNameControl.touched) {
        <mat-error>File name is required</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="confirm()">Download</button>
  </mat-dialog-actions>
</div>
